module.exports = __webpack_public_path__ + "static/media/icon_list_table.2e6baf02.svg";